// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CreateDTGSize_closeButton__qqYfg"};